export default {
  name: 'MainRadio',
  data() {
    return {};
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: [String, Number, Boolean, null],
      default: null
    },
    data: {
      type: [String, Number, Boolean],
      required: true
    },
    name: {
      type: String,
      default: 'Radio',
      required: true
    },
    title: {
      type: String,
      default: 'Radio'
    }
  },
  created() {},
  computed: {},
  methods: {}
};
